module.exports = __webpack_public_path__ + "img/24.a68a303d.png";